import React, {useState, useEffect} from "react";
import UsersDataService from "../services/users";
import {Link} from "react-router-dom";

const Leaderboard = props => {
  const [users, setUsers] = useState([]);
  const [searchUsername, setSearchUsername] = useState("");

  useEffect(() => {
    retrieveUsers();
  }, [])

  const retrieveUsers = () => {
    UsersDataService.getAll().then(response => {
      console.log(response.data);
      setUsers(response.data.users);
    }).catch(e => {
      console.error(`Error retrieving users: ${e}`);
    })
  };

  const refreshList = () => {
    retrieveUsers();
  };

  const find = (query, by) => {
    UsersDataService.find(query, by)
    .then(response => {
      console.log(response.data);
      setUsers(response.data.users);
    })
    .catch(e => {
      console.error(`Error retrieving users: ${e}`);
    })
  }

  const findByUsername = () => {
    find(searchUsername, "username")
  };

  return (
    <div style={{textAlign: "center"}}>
        <Link to = {"/"}><h3>Back to game</h3></Link>
        <ul className="list-group" style={{width: 200, display:"inline-block"}}>
          {users.map((user, index) => {
            const username = `${user.username}`;
            const highscore = `${user.highscore}`
            const rank_color = index == 0 ? "gold" : index == 1 ? "silver" : index == 2 ? "rgb( 205, 127, 50 )" : "";
            return (
              <div className = "leaderboard_entry" key = {user._id}>
                <Link to = {`/user/${user.username}`}><li className="list-group-item" style = {{ backgroundColor: rank_color}}>{index + 1}. {username} - {highscore}</li></Link>
              </div>
            )
          })}
        </ul>
    </div>
  );
  
  
}

export default Leaderboard;
